import styled from 'styled-components'

const SelectOption = styled.option`
  display: block;
  font-weight: normal;
  min-height: 1.2em;
  padding: 0 2px 1px;
  white-space: pre;
`

export default SelectOption
